import * as ImagePicker from "expo-image-picker";
import { useIntl } from "react-intl";
import { useCallback } from "react";
import { Platform } from "react-native";

import { processImage } from "../../../Image/processImage";
import { openAppSettings } from "./openAppSettings";
import { addBreadcrumb, captureMessage } from "../../../../common/sentry";
import { useAlert } from "../../../../common/Alert";

export function useOpenImagePicker() {
  const intl = useIntl();
  const Alert = useAlert();
  const openImagePicker = useCallback(async () => {
    const { granted, canAskAgain, expires, status, accessPrivileges } =
      await ImagePicker.requestMediaLibraryPermissionsAsync();
    addBreadcrumb({
      category: "permission",
      message: "Request media library permission",
      data: {
        granted,
        expires,
        status,
        canAskAgain,
        accessPrivileges,
      },
    });
    if (!granted) {
      captureMessage("Image picker access not granted");
      Alert.alert(
        intl.formatMessage({
          defaultMessage: "Photos access required",
          description: "openImagePicker:NoPhotosAcessAlert: title",
        }),
        intl.formatMessage({
          defaultMessage: "Let Storesprint access Photos",
          description: "openImagePicker:NoPhotosAcessAlert: description",
        }),
        [
          {
            onPress: openAppSettings,
            text: intl.formatMessage({
              defaultMessage: "Enable Photos Access",
              description:
                "openImagePicker:NoPhotosAcessAlert: option: enable photos",
            }),
            style: "default",
          },
          {
            text: intl.formatMessage({
              defaultMessage: "Cancel",
              description: "openImagePicker:NoPhotosAcessAlert: option: cancel",
            }),
            style: "cancel",
          },
        ]
      );
      return null;
    }
    const result = await ImagePicker.launchImageLibraryAsync({
      allowsMultipleSelection: false,
      allowsEditing: false,
      mediaTypes: ["images"],
      exif: true,
      quality: 1,
    });

    if (result.canceled === false && result.assets.length > 0) {
      const r = result.assets[0];
      const { exif, height, width } = r;
      const { uri } = await processImage(r.uri);
      const orientationValue = exif?.["Orientation"];
      const switchValues =
        Platform.OS === "android" &&
        (orientationValue === 5 || orientationValue === 6);
      return {
        width: switchValues ? height : width,
        height: switchValues ? width : height,
        uri,
      };
    }
    return null;
  }, [Alert, intl]);
  return openImagePicker;
}
